module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc",
      "title": "Copyright"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstsmall",
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("InterVarsity Press"), _c('br'), _vm._v("\n  P.O. Box 1400"), _c('br'), _vm._v("\n  Downers Grove, IL 60515-1426"), _c('br'), _vm._v("\n  World Wide Web: "), _c('a', {
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ivpress.com")]), _c('br'), _vm._v("\n  E-mail: "), _c('a', {
    attrs: {
      "href": "mailto:email@ivpress.com"
    }
  }, [_vm._v("email@ivpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("© 2013 by Robert F. Cochran Jr. and David VanDrunen have asserted their right under the Copyright, Designs and Patents Act, 1988, to be identified as Author of this work.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior permission of InterVarsity Press.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("InterVarsity Press"), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _vm._v(", USA, is the book-publishing division of InterVarsity Christian Fellowship/USA"), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("® ")]), _vm._v("www.intervarsity.org and a member movement of the International Fellowship of Evangelical Students.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("ESV")]), _vm._v(" are from "), _c('span', {
    staticClass: "char-style-override-9"
  }, [_c('em', [_vm._v("The Holy Bible, English Standard Version")])]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("ESV")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _vm._v(" copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("nab")]), _vm._v(" are from the "), _c('span', {
    staticClass: "char-style-override-9"
  }, [_c('em', [_vm._v("New American Bible, revised edition")])]), _vm._v(" © 2010, 1991, 1986, 1970 Confraternity of Christian Doctrine, Washington, D.C., and are used by permission of the copyright owner. All rights reserved. No part of the "), _c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("New American Bible")]), _vm._v(" may be reproduced in any form without permission in writing from the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("niv")]), _vm._v(" are from the "), _c('span', {
    staticClass: "Strong char-style-override-9"
  }, [_vm._v("THE HOLY BIBLE, NEW INTERNATIONAL VERSION")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "Strong char-style-override-9"
  }, [_vm._v(", NIV")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.")]), _c('span', {
    staticClass: "Strong char-style-override-13"
  }, [_vm._v("™")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("Used by permission. All rights reserved worldwide.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("Scripture quotations marked")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-14"
  }, [_vm._v("niv")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("1984 are from the")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-9"
  }, [_c('em', [_vm._v("Holy Bible, New International Version")])]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "Strong char-style-override-9"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-10"
  }, [_vm._v("NIV")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "Strong char-style-override-9"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("Copyright © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan Publishing House. All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("NRSV")]), _vm._v(" are from the "), _c('span', {
    staticClass: "char-style-override-9"
  }, [_c('em', [_vm._v("New Revised Standard Version of the Bible,")])]), _vm._v(" copyright 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("RSV")]), _vm._v(" are from the "), _c('span', {
    staticClass: "char-style-override-9"
  }, [_c('em', [_vm._v("Revised Standard Version of the Bible,")])]), _vm._v(" copyright 1946, 1952, 1971 by the Division of Christian Education of the National Council of the Churches of Christ in the U.S.A. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Cover design: David Fassett"), _c('br'), _vm._v("\n  Images: Ornate fountain with statue: "), _c('span', {
    staticClass: "Strong char-style-override-15"
  }, [_vm._v("©")]), _vm._v(" WALTER ZERLA/cultura/Corbis"), _c('br'), _vm._v("\n  Line of Torah: Matthew Ragen/iStocckphoto"), _c('br'), _vm._v("\n  Supreme Court columns: "), _c('span', {
    staticClass: "Strong char-style-override-12"
  }, [_vm._v("© Joel Carillet/iStockphoto")])]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("ISBN 978-0-8308-9559-5 (digital)"), _c('br'), _vm._v("\n  ISBN 978-0-8308-2573-8 (print)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 60
// module chunks = 0